import { c as _c } from "react/compiler-runtime";
import { useDpStore } from "@/store/dpStore";
import { Alert, Button, CircularProgress, Dialog, IconButton, List, ListItem, ListItemIcon, ListItemText, TextField } from "@mui/material";
import LocationHeader from "../LocationHeader";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import { useMemo, useRef, useEffect } from "react";
import Image from "next/image";
import { usePlacesAutocomplete } from "../../../_hooks/usePlacesAutocomplete";
import { formatPlacePrediction } from "@/lib/utils/places-utils";
import { pushGtmEvent } from "@/lib/utils/gtmEventHandler";
export default function LocationModal(t0) {
  const $ = _c(58);
  const {
    digitalProfile
  } = t0;
  const {
    enquiryFormData,
    setEnquiryFormData,
    isLoactionModalOpen,
    setIsLoactionModalOpen,
    searchQuery,
    setSearchQuery,
    setSiteLoactionMode,
    setIsMapModalOpen
  } = useDpStore();
  const eventPayload = {
    homeowner_contact_number: enquiryFormData.whatsappNumber,
    homeowner_site_address: enquiryFormData.siteLocation,
    pincode: typeof window !== "undefined" ? localStorage.getItem("multiplyonboarding_pincode") : "",
    contractor_name: digitalProfile?.profileName,
    contractor_id: digitalProfile?.contractorId,
    contractor_phone_number: digitalProfile?.phoneNumber,
    contractor_profile_id: digitalProfile?.profileName
  };
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      borderBottom: "1px solid var(--colorSecondarySecondaryContainer, #DEE1F9)",
      backgroundColor: "var(--colorSurfaceSurfaceVar, #F1F5FF)"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const containerStyle = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      padding: "8px",
      color: "var(--textPrimaryPrimary, #1B1C17)"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const iconButtonSx = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      "& .MuiInputBase-input": {
        fontSize: "16px",
        color: "var(--textPrimaryPrimary, #1B1C17)",
        paddingBottom: "8px"
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const textFieldSx = t3;
  const searchInputRef = useRef(null);
  let t4;
  let t5;
  if ($[3] !== isLoactionModalOpen) {
    t4 = () => {
      if (!isLoactionModalOpen) {
        return;
      }
      const timer = setTimeout(() => {
        searchInputRef.current?.focus();
      }, 500);
      return () => clearTimeout(timer);
    };
    t5 = [isLoactionModalOpen];
    $[3] = isLoactionModalOpen;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  if ($[6] !== setSearchQuery) {
    t6 = e => {
      setSearchQuery(e.target.value);
    };
    $[6] = setSearchQuery;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const handleSearchChange = t6;
  let t7;
  if ($[8] !== setSearchQuery) {
    t7 = () => {
      setSearchQuery("");
    };
    $[8] = setSearchQuery;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleClearClick = t7;
  let t8;
  if ($[10] !== setIsLoactionModalOpen) {
    t8 = () => {
      setIsLoactionModalOpen(false);
    };
    $[10] = setIsLoactionModalOpen;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const handleBackClick = t8;
  let t9;
  if ($[12] !== searchQuery) {
    t9 = searchQuery?.trim() || "";
    $[12] = searchQuery;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const trimmedQuery = t9;
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      debounceMs: 300
    };
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const {
    predictions,
    isLoading,
    error
  } = usePlacesAutocomplete(trimmedQuery, t10);
  let t11;
  if ($[15] !== predictions) {
    t11 = predictions.map(_temp);
    $[15] = predictions;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const formattedPredictions = t11;
  const handleSelectLocation = location => {
    searchInputRef.current?.blur();
    const locationText = location.fullAddress || `${location.primary}${location.secondary ? `, ${location.secondary}` : ""}`;
    setEnquiryFormData({
      ...enquiryFormData,
      siteLocation: locationText
    });
    setIsLoactionModalOpen(false);
    setSiteLoactionMode("map");
    pushGtmEvent({
      event_name: "location_suggestion_selected",
      ...eventPayload
    });
  };
  let t12;
  if ($[17] !== setIsLoactionModalOpen || $[18] !== setSiteLoactionMode) {
    t12 = () => {
      setSiteLoactionMode("manual");
      setIsLoactionModalOpen(false);
    };
    $[17] = setIsLoactionModalOpen;
    $[18] = setSiteLoactionMode;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const handleEnterManuallyClick = t12;
  let t13;
  if ($[20] !== setIsLoactionModalOpen || $[21] !== setIsMapModalOpen || $[22] !== setSiteLoactionMode) {
    t13 = () => {
      setSiteLoactionMode("map");
      setIsLoactionModalOpen(false);
      setIsMapModalOpen(true);
    };
    $[20] = setIsLoactionModalOpen;
    $[21] = setIsMapModalOpen;
    $[22] = setSiteLoactionMode;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const handleSelectOnMapClick = t13;
  const T0 = Dialog;
  const t14 = true;
  let t15;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ArrowBackIcon />;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== handleBackClick) {
    t16 = <IconButton onClick={handleBackClick} type="button" sx={iconButtonSx} aria-label="Go back">{t15}</IconButton>;
    $[25] = handleBackClick;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      input: {
        disableUnderline: true
      }
    };
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== handleSearchChange || $[29] !== searchQuery) {
    t18 = <TextField fullWidth={true} inputRef={searchInputRef} placeholder="Search your location" value={searchQuery} onChange={handleSearchChange} variant="standard" slotProps={t17} sx={textFieldSx} />;
    $[28] = handleSearchChange;
    $[29] = searchQuery;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== handleClearClick || $[32] !== searchQuery) {
    t19 = searchQuery && <IconButton onClick={handleClearClick} sx={iconButtonSx} aria-label="Clear search"><CloseIcon /></IconButton>;
    $[31] = handleClearClick;
    $[32] = searchQuery;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t16 || $[35] !== t18 || $[36] !== t19) {
    t20 = <div className="flex items-center gap-2 px-4 py-3" style={containerStyle}>{t16}{t18}{t19}</div>;
    $[34] = t16;
    $[35] = t18;
    $[36] = t19;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== isLoading) {
    t21 = isLoading && <div className="flex items-center justify-center py-8"><CircularProgress size={24} sx={{
        color: "var(--colorPrimaryPrimary, #004BEE)"
      }} /><span className="m3-body-medium ml-3" style={{
        fontFamily: "var(--m3BodyMediumFontFamily, Manrope)",
        fontSize: "var(--m3BodyMediumFontSize, 14px)",
        fontWeight: "var(--m3BodyMediumFontWeight, 500)",
        letterSpacing: "var(--m3BodyMediumLetterSpacing, 0.25)",
        textTransform: "var(--m3BodyMediumTextCase, none)",
        textDecoration: "var(--m3BodyMediumTextDecoration, none)",
        color: "var(--textSecondarySecondary, #5E5F59)"
      }}>Searching...</span></div>;
    $[38] = isLoading;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== error || $[41] !== isLoading) {
    t22 = error && !isLoading && <div className="px-4 py-2"><Alert severity="error" sx={{
        backgroundColor: "var(--colorErrorErrorContainer, #F9DEDC)",
        color: "var(--textErrorError, #B3261E)"
      }}>{error}</Alert></div>;
    $[40] = error;
    $[41] = isLoading;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  const t23 = !isLoading && !error && trimmedQuery && <List sx={{
    padding: 0
  }}>{formattedPredictions.length > 0 ? formattedPredictions.filter(_temp2).map((location_1, index) => <ListItem key={location_1.placeId || `location-${index}`} onClick={() => {
      handleSelectLocation(location_1);
    }} sx={{
      padding: "16px",
      borderBottom: "1px solid var(--colorSecondarySecondaryContainer, #DEE1F9)",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "rgba(0, 75, 238, 0.04)"
      }
    }}><ListItemIcon sx={{
        minWidth: "40px"
      }}><Image src="/icons/location-icon.svg" alt="Location" width={24} height={24} unoptimized={true} style={{
          display: "block"
        }} /></ListItemIcon><ListItemText primary={location_1.primary || location_1.fullAddress} secondary={location_1.secondary} slotProps={{
        primary: {
          className: "m3-body-large",
          style: {
            fontFamily: "var(--m3BodyLargeFontFamily, Manrope)",
            fontSize: "var(--m3BodyLargeFontSize, 16px)",
            fontWeight: "var(--m3BodyLargeFontWeight, 500)",
            letterSpacing: "var(--m3BodyLargeLetterSpacing, 0.5)",
            textTransform: "var(--m3BodyLargeTextCase, none)",
            textDecoration: "var(--m3BodyLargeTextDecoration, none)",
            color: "var(--textPrimaryPrimary, #1B1C17)"
          }
        },
        secondary: {
          className: "m3-body-medium",
          style: {
            fontFamily: "var(--m3BodyMediumFontFamily, Manrope)",
            fontSize: "var(--m3BodyMediumFontSize, 14px)",
            fontWeight: "var(--m3BodyMediumFontWeight, 500)",
            letterSpacing: "var(--m3BodyMediumLetterSpacing, 0.25)",
            textTransform: "var(--m3BodyMediumTextCase, none)",
            textDecoration: "var(--m3BodyMediumTextDecoration, none)",
            color: "var(--textSecondarySecondary, #5E5F59)"
          }
        }
      }} /></ListItem>) : <div className="px-4 py-8 text-center"><p className="m3-body-medium" style={{
        fontFamily: "var(--m3BodyMediumFontFamily, Manrope)",
        fontSize: "var(--m3BodyMediumFontSize, 14px)",
        fontWeight: "var(--m3BodyMediumFontWeight, 500)",
        letterSpacing: "var(--m3BodyMediumLetterSpacing, 0.25)",
        textTransform: "var(--m3BodyMediumTextCase, none)",
        textDecoration: "var(--m3BodyMediumTextDecoration, none)",
        color: "var(--textSecondarySecondary, #5E5F59)"
      }}>No locations found</p></div>}</List>;
  let t24;
  if ($[43] !== handleSelectOnMapClick) {
    t24 = <Button onClick={handleSelectOnMapClick} variant="outlined" fullWidth={true} className="!rounded-full !border-[--colorSecondarySecondary] !text-[--textSecondarySecondary] ">Select on map</Button>;
    $[43] = handleSelectOnMapClick;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== handleEnterManuallyClick) {
    t25 = <Button onClick={handleEnterManuallyClick} variant="outlined" fullWidth={true} className="!rounded-full !border-[--colorSecondarySecondary] !text-[--textSecondarySecondary] ">Enter manually</Button>;
    $[45] = handleEnterManuallyClick;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== t24 || $[48] !== t25) {
    t26 = <div className="flex w-full gap-2 p-4">{t24}{t25}</div>;
    $[47] = t24;
    $[48] = t25;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== T0 || $[51] !== isLoactionModalOpen || $[52] !== t20 || $[53] !== t21 || $[54] !== t22 || $[55] !== t23 || $[56] !== t26) {
    t27 = <T0 open={isLoactionModalOpen} fullScreen={t14}>{t20}{t21}{t22}{t23}{t26}</T0>;
    $[50] = T0;
    $[51] = isLoactionModalOpen;
    $[52] = t20;
    $[53] = t21;
    $[54] = t22;
    $[55] = t23;
    $[56] = t26;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  return t27;
}
function _temp2(location_0) {
  return location_0.primary || location_0.fullAddress;
}
function _temp(prediction) {
  return formatPlacePrediction(prediction);
}